import React, { useEffect, useMemo, useState } from "react";
import { Blacked } from "../../../../CRM/components/styles";
import { ReactComponent as ModalCloseIcon } from "../../../../assets/HomeTownIcon/ModalCloseIcon.svg";
import styled from "styled-components";
import { MEDIA_URL } from "../../../../app/constants/APIKEYS";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";
import {AutoPlayVideo} from "../../../Common/AutoPlayVideo";



pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    "pdfjs-dist/build/pdf.worker.min.mjs",
    import.meta.url
).toString();

const options = {
    cMapUrl: "/cmaps/",
    standardFontDataUrl: "/standard_fonts/",
};

type PreviewMonitorProps = {
    setIsPreviewModal: (v: boolean) => void;
    itemId: number | string | null;
    adminContentsList: any[];
};

// --------- 파일 타입 헬퍼 ---------
const isPdf = (url?: string | null) =>
    !!url && /\.pdf(\?|#|$)/i.test(url);

const isVideo = (url?: string | null) =>
    !!url && /\.(mp4|webm|ogg|ogv|mov|m4v)(\?|#|$)/i.test(url);

export const PreviewMonitor: React.FC<PreviewMonitorProps> = ({
                                                                  setIsPreviewModal,
                                                                  itemId,
                                                                  adminContentsList,
                                                              }) => {
    const [selectedItem, setSelectedItem] = useState<any>(null);
    const [numPages, setNumPages] = useState<number>();
    const [pageNumber, setPageNumber] = useState<number>(1);

    useEffect(() => {
        const found = adminContentsList?.find((item) => itemId === item?.adId) ?? null;
        setSelectedItem(found);
    }, [adminContentsList, itemId]);

    const firstUrl: string | null = useMemo(() => {
        const u = selectedItem?.fileList?.[0]?.url;
        return typeof u === "string" && u.length > 0 ? u : null;
    }, [selectedItem]);

    const fullSrc = useMemo(() => {
        if (!firstUrl) return null;
        return firstUrl.startsWith("http") ? firstUrl : MEDIA_URL + firstUrl;
    }, [firstUrl]);

    function onDocumentLoadSuccess({ numPages }: { numPages: number }): void {
        setNumPages(numPages);
    }

    const RenderMedia = ({
                             boxWidth,
                             boxHeight,
                         }: {
        boxWidth?: number;
        boxHeight?: number;
    }) => {
        if (!fullSrc) {
            return <BlankBox style={{ width: boxWidth, height: boxHeight }} />;
        }

        if (isPdf(firstUrl)) {
            return (
                <Document file={fullSrc} options={options} onLoadSuccess={onDocumentLoadSuccess}>
                    <div
                        style={{
                            width: boxWidth,
                            height: boxHeight,
                            display: "flex",
                            justifyContent: "center",
                            backgroundColor: "#D9D9D9",
                        }}
                    >
                        <Page pageNumber={pageNumber} height={boxHeight ? boxHeight - 0.01 : undefined} />
                    </div>
                </Document>
            );
        }

        if (isVideo(firstUrl)) {
            return (
                <div
                    style={{
                        width: boxWidth,
                        height: boxHeight,
                        backgroundColor: "#D9D9D9",
                    }}
                >
                    <AutoPlayVideo
                        src={fullSrc}
                        controls={false}   // 필요 시 true
                        // loop
                    />
                </div>
            );
        }

        // 이미지(그 외)
        return (
            <img
                src={fullSrc}
                alt=""
                style={{
                    width: boxWidth ? `${boxWidth}px` : "100%",
                    height: boxHeight ? `${boxHeight}px` : "100%",
                    backgroundColor: "#D9D9D9",
                    objectFit: "cover",
                }}
            />
        );
    };

    return (
        <>
            <Blacked onClick={() => setIsPreviewModal(false)} />
            <ModalWrapper className={"scroll-container"}>
                <ModalHeader>
                    <ModalTitle>미리보기</ModalTitle>
                    <CloseIconSVG as={ModalCloseIcon} onClick={() => setIsPreviewModal(false)} />
                </ModalHeader>

                {/* 전면 */}
                <Contents>
                    <MonitorTitle>전면</MonitorTitle>
                    <MonitorWrapper style={{ display: "flex", justifyContent: "center" }}>
                        <RenderMedia boxWidth={413.61} boxHeight={233.42} />
                    </MonitorWrapper>
                </Contents>

                {/* 2면 */}
                <Contents>
                    <MonitorTitle>2면</MonitorTitle>
                    <MonitorWrapper style={{ padding: 4 }}>
                        <div style={{ display: "flex", justifyContent: "center", gap: 6 }}>
                            <RenderMedia boxWidth={198} boxHeight={142.01} />
                            <TwoBig />
                        </div>
                        <div style={{ display: "flex", justifyContent: "center", gap: 5, marginTop: 5 }}>
                            <TwoSmall />
                            <TwoSmall />
                            <TwoSmall />
                            <TwoSmall />
                        </div>
                    </MonitorWrapper>
                </Contents>

                {/* 6면 */}
                <Contents>
                    <MonitorTitle>6면</MonitorTitle>
                    <MonitorWrapper style={{ padding: 4 }}>
                        <div style={{ display: "flex", justifyContent: "center", gap: 3 }}>
                            <RenderMedia boxWidth={133} boxHeight={111.55} />
                            <SixBox />
                            <SixBox />
                        </div>
                        <div style={{ display: "flex", justifyContent: "center", gap: 3, marginTop: 3 }}>
                            <SixBox />
                            <SixBox />
                            <SixBox />
                        </div>
                    </MonitorWrapper>
                </Contents>
            </ModalWrapper>
        </>
    );
};

/* ----------------- styles ----------------- */

const ModalWrapper = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-height: 820px;
    overflow-y: scroll;
    width: 580px;
    background-color: #fff;
    border-radius: 8px;
    padding: 24px;
    z-index: 99999;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const ModalHeader = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
`;

const CloseIconSVG = styled.svg`
    width: 24px;
    cursor: pointer;
`;

const ModalTitle = styled.div`
    font-family: Pretendard, sans-serif;
    font-weight: 600;
    font-size: 18px;
    line-height: 21.48px;
    color: #2e2559;
`;

const Contents = styled.div`
    margin-top: 45px;
    font-weight: 400;
    font-size: 15px;
    line-height: 17.9px;
    font-family: Pretendard, sans-serif;
    color: #000000;
    white-space: pre-wrap;
    text-align: center;
`;

const MonitorTitle = styled.div`
    font-weight: 600;
    font-size: 15px;
    line-height: 17.9px;
    font-family: pretendard, sans-serif;
    margin-bottom: 10px;
`;

const MonitorWrapper = styled.div`
    border: 12.87px solid #000000;
    width: 437.61px;
    height: 257.42px;
`;

const BlankBox = styled.div`
    background-color: #d9d9d9;
`;

const TwoBig = styled.div`
    background-color: #d9d9d9;
    width: 198px;
    height: 142.01px;
`;

const TwoSmall = styled.div`
    background-color: #d9d9d9;
    width: 96.96px;
    height: 77.01px;
`;

const SixBox = styled.div`
    background-color: #d9d9d9;
    width: 133px;
    height: 111.55px;
`;
